import ApiService from "@/common/api.service";

export const MfrService = {
    async getRegions(params) {
        return ApiService.get(`/mfr/regions${params}`);
    },
    async getTrees(params) {
        return ApiService.get(`/mfr/trees${params}`);
    },
    async getFacilities(params) {
        return ApiService.get(`/mfr/facilities${params}`);
    },


    //drp
    async getRegionsDrp() {
        return ApiService.get(`/mfr/regions/drp`);
    },
    async getZonesDrp(id) {
        return ApiService.get(`/mfr/zones/drp?regionId=${id}`);
    },
    async getWoredasDrp(id) {
        return ApiService.get(`/mfr/woredas/drp?zoneId=${id}`);
    },
    async getFacilitiesDrp(id) {
        return ApiService.get(`/mfr/facilities/drp?woredaId=${id}`);
    },
};
